'use client';

function isDocumentElement(element) {
    return element === document.documentElement || element instanceof Document;
}
function isBodyElement(element) {
    return element === document.body;
}
function isOverflowSet(overflowValue) {
    return (overflowValue === 'auto' ||
        overflowValue === 'hidden' ||
        overflowValue === 'scroll' ||
        overflowValue === 'overlay');
}
function isAbsolutePositioning(element) {
    var position = window.getComputedStyle(element).position;
    return position === 'absolute';
}
function getScrollableParent(element) {
    if (isDocumentElement(element) || isBodyElement(element)) {
        return window;
    }
    var computedStyle = window.getComputedStyle(element);
    if (isOverflowSet(computedStyle.overflow) ||
        isOverflowSet(computedStyle.overflowX) ||
        isOverflowSet(computedStyle.overflowY)) {
        if (!isAbsolutePositioning(element)) {
            return element;
        }
    }
    if (element.parentNode) {
        return getScrollableParent(element.parentNode);
    }
    return window;
}

export { getScrollableParent as default };
//# sourceMappingURL=getScrollableParent.js.map
